import React, { useState, useEffect } from "react";
import styles from "./WaterIntake.module.css";

const WaterIntake = () => {

  const [showToast, setShowToast] = useState(false);

  const [vibrationEnabled, setVibrationEnabled] = useState(false);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);

  useEffect(() => {
    document.title = "Calculadora de Consumo de Água Diário | Descubra Quantos Litros Beber - Fohattech";
    loadSavedData();

    const savedVibration = localStorage.getItem("waterVibration");
    const savedNotification = localStorage.getItem("waterNotification");

    if (savedVibration === "true") setVibrationEnabled(true);
    if (savedNotification === "true") setNotificationsEnabled(true);

  }, []);

  const [weight, setWeight] = useState("");
  const [result, setResult] = useState(null);
  const [consumed, setConsumed] = useState(0);
  const [completedToday, setCompletedToday] = useState(false);

  const todayString = new Date().toDateString();

  // ================= FRASE =================
  const getMessage = (p) => {
    if (p === 100) return "🔥 Meta concluída! Seu corpo agradece!";
    if (p >= 70) return "💪 Quase lá! Não desista agora!";
    if (p >= 50) return "⚡ Bom progresso! Continue!";
    if (p >= 20) return "🚀 Você começou, já é um ótimo passo!";
    return "🌱 Comece com pequenos goles, você consegue!";
  };

  // ================= CALCULO =================
  const calculateWater = () => {
    if (!weight) return;

    const ml = weight * 35;
    setResult(ml);

    localStorage.setItem("waterGoal", ml);
    localStorage.setItem("waterDate", todayString);
  };

  // ================= PROGRESSO =================
  const addWater = (amount) => {
    if (completedToday) return;

    const newValue = consumed + amount;
    setConsumed(newValue);
    localStorage.setItem("waterConsumed", newValue);

    if (result && newValue >= result) {
      setCompletedToday(true);
      localStorage.setItem("waterCompleted", "true");
    }
  };

  // ================= LOAD =================
  const loadSavedData = () => {
    const savedDate = localStorage.getItem("waterDate");
    const savedGoal = localStorage.getItem("waterGoal");
    const savedConsumed = localStorage.getItem("waterConsumed");
    const completed = localStorage.getItem("waterCompleted");

    if (savedDate === todayString) {
      if (savedGoal) setResult(parseInt(savedGoal));
      if (savedConsumed) setConsumed(parseInt(savedConsumed));
      if (completed) setCompletedToday(true);
    } else {
      localStorage.setItem("waterDate", todayString);
      localStorage.setItem("waterConsumed", 0);
      localStorage.removeItem("waterCompleted");
      setConsumed(0);
      setCompletedToday(false);
    }
  };

  const percentage = result ? Math.min((consumed / result) * 100, 100) : 0;

  // ================= SHARE =================
  async function handleShare() {
    try {
      if (navigator.share) {
        await navigator.share({
          title: "Calculadora de Consumo de Água",
          text: "Descubra quanta água você deve beber por dia!",
          url: window.location.href,
        });
      } else {
        fallbackShare();
      }
    } catch {}
  }

  function fallbackShare() {
    navigator.clipboard.writeText(window.location.href);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  }

  // ================= TOGGLES =================

  const toggleNotification = async () => {
    const newValue = !notificationsEnabled;

    if (newValue) {
      if ("Notification" in window) {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
          alert("Você precisa permitir notificações para ativar essa função.");
          return;
        }
      }
    }

    setNotificationsEnabled(newValue);
    localStorage.setItem("waterNotification", newValue);
  };

  const toggleVibration = () => {
    const newValue = !vibrationEnabled;
    setVibrationEnabled(newValue);
    localStorage.setItem("waterVibration", newValue);
  };

  // ================= NOTIFICAÇÃO =================
  useEffect(() => {
    const interval = setInterval(() => {

      if (!notificationsEnabled) return;
      if (!result || completedToday) return;

      const percent = Math.min((consumed / result) * 100, 100);
      if (percent >= 100) return;

      sendNotification(percent);

    }, 1000 * 60 * 30);

    return () => clearInterval(interval);
  }, [result, completedToday, notificationsEnabled]);

  function sendNotification(percentage) {
    if (!("Notification" in window)) return;
    if (Notification.permission !== "granted") return;

    let message = "";

    if (percentage < 30) {
      message = "😬 Você ainda bebeu pouca água hoje!";
    } else if (percentage < 70) {
      message = "⚡ Bom progresso! Continue bebendo água.";
    } else {
      message = "💪 Quase lá! Continua firme!";
    }

    new Notification("💧 Hora de beber água!", {
      body: `${message} (${percentage.toFixed(0)}%)`,
    });

    if (vibrationEnabled && "vibrate" in navigator) {
      navigator.vibrate([200, 100, 200]);
    }
  }

  return (
    <div className={styles.container}>

      <h2 className={styles.title}>Calculadora de Consumo de Água Diário</h2>

      <p className={styles.subtitle}>
        Descubra quantos litros de água você deve beber por dia com base no seu peso.
      </p>

      {/* SEO ORIGINAL + EXPANDIDO */}
      <div className={styles.infoBox}>
        <h3>Como funciona?</h3>
        <p>
          Manter uma boa hidratação é essencial para o funcionamento correto do corpo humano. Esta ferramenta foi criada para calcular de forma rápida e simples a quantidade ideal de água que você deve consumir diariamente com base no seu peso corporal. O cálculo utiliza uma média recomendada de aproximadamente 35 ml de água por quilo, ajudando você a ter uma referência prática para o seu dia a dia. Além de calcular, a ferramenta também permite acompanhar seu consumo ao longo do dia através de uma barra de progresso visual, facilitando o controle da sua hidratação. Isso é especialmente útil para quem esquece de beber água ou quer criar o hábito de se manter hidratado. Tudo funciona diretamente no seu navegador, sem necessidade de cadastro ou envio de dados para servidores, garantindo mais privacidade e rapidez. Ideal para quem busca melhorar a saúde, aumentar a disposição, melhorar o funcionamento do organismo e até auxiliar em atividades físicas.
        </p>

        <h3>O que você pode fazer?</h3>
        <ul className={styles.listaDoQuePodeFazer}>
          <li>✔ Calcular sua meta diária de água</li>
          <li>✔ Acompanhar seu progresso em tempo real</li>
          <li>✔ Criar o hábito de beber água</li>
          <li>✔ Melhorar sua saúde e bem-estar</li>
        </ul>

        {/* NOVO TEXTO SEO (ADICIONADO) */}
        <h3>Lembretes e notificações inteligentes</h3>
        <p>
          Para facilitar ainda mais o acompanhamento da sua hidratação diária, esta ferramenta também permite ativar notificações automáticas diretamente no seu navegador. Esses lembretes ajudam você a não esquecer de beber água ao longo do dia, criando consistência e melhorando seus hábitos de saúde. Você pode escolher ativar ou desativar as notificações a qualquer momento, além de habilitar vibração em dispositivos móveis para tornar os alertas mais perceptíveis. Essa funcionalidade é ideal para quem tem rotina corrida e precisa de pequenos incentivos ao longo do dia para manter o consumo adequado de água. Todas as configurações ficam salvas apenas no seu dispositivo, garantindo privacidade total.
        </p>
      </div>

      <div className={styles.toolBox}>
        <input
          type="number"
          placeholder="Digite seu peso (kg)"
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
          className={styles.input}
        />

        <button onClick={calculateWater} className={styles.button}>
          Calcular
        </button>
      </div>

      {result && (
        <div className={styles.resultBox}>

          <h3>
            Você deve beber{" "}
            <span className={styles.highlight}>
              {(result / 1000).toFixed(2)}L ({result} ml)
            </span>{" "}
            por dia
          </h3>

          <div className={styles.progressBar}>
            <div
              className={styles.progress}
              style={{ width: `${percentage}%` }}
            ></div>
          </div>

          <p>{percentage.toFixed(0)}% da meta diária</p>
          <p>{getMessage(percentage)}</p>

          {!completedToday && (
            <div className={styles.buttons}>
              <button onClick={() => addWater(250)}>+250ml</button>
              <button onClick={() => addWater(500)}>+500ml</button>
              <button onClick={() => addWater(1000)}>+1L</button>
            </div>
          )}

          {completedToday && (
            <div className={styles.successBox}>
              🎉 Parabéns! Você completou sua meta hoje!
              <p>Volte amanhã para manter sua hidratação em dia 💧</p>
            </div>
          )}

          {/* TOGGLES BONITOS */}
          <div className={styles.toggleBox}>
            <span>Ativar notificações 🔔</span>
            <div
              className={`${styles.toggle} ${notificationsEnabled ? styles.active : ""}`}
              onClick={toggleNotification}
            >
              <div className={styles.circle}></div>
            </div>
          </div>

          {notificationsEnabled && (
            <div className={styles.toggleBox}>
              <span>Ativar vibração 📳</span>
              <div
                className={`${styles.toggle} ${vibrationEnabled ? styles.active : ""}`}
                onClick={toggleVibration}
              >
                <div className={styles.circle}></div>
              </div>
            </div>
          )}

          <button onClick={handleShare} className={styles.buttonShare}>
            Compartilhar esta ferramenta 🔗
          </button>

        </div>
      )}

      <div className={styles.finalText}>
        <p>
          Beber água regularmente ajuda no funcionamento do cérebro, melhora a circulação sanguínea, regula a temperatura corporal e contribui para uma melhor qualidade de vida. Pequenos hábitos diários fazem grande diferença ao longo do tempo.
        </p>

        <p className={styles.warning}>
          Esta ferramenta é apenas informativa e não substitui orientação médica.
        </p>
      </div>

      <div id="BoxAfiliados"></div>

      {showToast && (
        <div className={styles.toast}>
          🔗 Link copiado com sucesso!
        </div>
      )}
    </div>
  );
};

export default WaterIntake;